function updateName(dogName) {
  const dog = dogName || document.querySelector('input[name="dog_name"]').value;

  if (dog) {
    document.querySelectorAll('[data-dog-name]').forEach(el => {
      const isPossessive = el.dataset.dogName === 'possessive';
      el.textContent = isPossessive ? `${dog}'s` : dog;
    });

    const dogNameEl = document.querySelector('#package-selector span.dogname');
    if (dogNameEl) dogNameEl.textContent = dog;
  }
}


export default updateName